var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{scopedSlots:_vm._u([{key:"code",fn:function(){return [_vm._v(" 404 ")]},proxy:true},{key:"description",fn:function(){return [_vm._v(" Упс, такої сторінки не існує ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }